"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _common = require("@nerdwallet/marketplace/selectors/common");
var _mortgages = require("@nerdwallet/marketplace/selectors/mortgages");
var DEFAULT_APPLY_TEXT = 'Learn More';
var getIssuerAnnotation = function getIssuerAnnotation(marketplaceEntity) {
  var issuerName = (0, _mortgages.getIssuerName)(marketplaceEntity);
  return issuerName && "at ".concat(issuerName);
};
var _default = function _default(_ref) {
  var marketplaceEntity = _ref.marketplaceEntity;
  var link = (0, _common.getApplyLink)(marketplaceEntity);
  return {
    additionalEventData: {
      lender: (0, _mortgages.getName)(marketplaceEntity)
    },
    annotationText: getIssuerAnnotation(marketplaceEntity),
    link: link,
    text: DEFAULT_APPLY_TEXT,
    vertical: 'Mortgage Lender'
  };
};
exports.default = _default;